import cs from 'classnames';
import { ReactNode } from 'react';

import { useHsDocument } from './HsShell';

import './hs.scss';

interface Props {
  /** 화면 뒤에 깔 배경(`HsBackdrop`). 빈 곳을 누르고 끄는 손가락은 배경으로 간다 */
  backdrop?: ReactNode;
  /** 제목 위 표시. 주지 않으면 로고(H), null이면 없음 */
  mark?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  /** 내용을 반투명 카드에 담는다(배경 위 양식: 로그인·회원가입) */
  card?: boolean;
  /** 카드 아래 한 줄(다른 화면으로 가는 링크 등) */
  footer?: ReactNode;
  className?: string;
  children?: ReactNode;
}

/**
 * 사이드바 없이 화면 가운데에 한 가지 일만 두는 단독 화면: 로그인·회원가입·404/403·dutch 멤버 선택.
 * 셸 밖에서도 hs 토큰·글꼴을 열고, iOS 웹뷰의 노치·홈 바 여백을 비운다.
 */
export default function HsCenterPage({
  backdrop,
  mark,
  title,
  description,
  card = false,
  footer,
  className,
  children,
}: Props) {
  useHsDocument();

  return (
    <div className={cs('HsCenterPage hs-app', className)}>
      {backdrop}
      <main className="hs-center">
        <div className={cs('hs-center-body', { card })}>
          {mark !== null && <div className="hs-center-mark">{mark ?? <span className="hs-mark">H</span>}</div>}
          {title && <h1 className="hs-center-title">{title}</h1>}
          {description && <p className="hs-center-desc">{description}</p>}
          {children}
        </div>
        {footer && <div className="hs-center-footer">{footer}</div>}
      </main>
    </div>
  );
}
